import { ITennisCalendar } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CalendarData } from "../types";
import { surfaceMap } from "../utils";
import { CATEGORIES } from "../../../utils/constants";
import { intcmpMap } from "../../../utils/intcmp";
import { isValidCalendarObject } from "./typeguards";
import { CreateSdapiCalendarWidgetInputSchema } from "appsync";

export const transformQuery = (obj: CalendarData): ITennisCalendar => {
  if (isValidCalendarObject(obj)) {
    CreateSdapiCalendarWidgetInputSchema().parse(obj.data.getSdapiCalendarWidget, {reportInput: true});
      const { circuitCalendarLink, filterList, tournaments, tournamentFilter } =
        obj?.data?.getSdapiCalendarWidget!;

      return {
        filterList,
        seoCtaUrl: circuitCalendarLink,
        tournamentFilter: CATEGORIES.includes(tournamentFilter.toLowerCase())
          ? tournamentFilter
          : null,
        tournaments:
          tournaments?.length &&
          tournaments.map((item) => {
            const { surface, ...rest } = item!;
            return {
              ...rest,
              surface: surface && surfaceMap[surface],
              trackingData: { intcmp: intcmpMap.calendar }
            };
          }),
      } as ITennisCalendar;
    
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CalendarQuery object',
      data: obj
    });
  }
};
